import request from '@/utils/request'

// 删除重复的 request 声明和拦截器配置
// 因为 @/utils/request 已经包含了必要的配置

/**
 * 获取试配订单列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回订单列表
 */
export const getTrialOrders = async (params = {}) => {
  return request({
    url: '/api/orders/trial',
    method: 'get',
    params
  });
};

/**
 * 创建试配订单
 * @param {Object} orderData 订单数据
 * @returns {Promise} 返回创建结果
 */
export const createTrialOrder = (orderData) => {
  return request({
    url: '/api/orders/trial',
    method: 'post',
    data: orderData
  });
};

/**
 * 获取试配订单详情
 * @param {string} orderId 订单ID
 * @returns {Promise} 返回订单详情
 */
export const getTrialOrderById = (orderId) => {
  return request({
    url: `/api/orders/trial/${orderId}`,
    method: 'get'
  });
};


// 更新试配订单
export const updateTrialOrder = (orderData) => {
  return request({
    url: `/api/orders/trial/${orderData.id}`,
    method: 'put',
    data: orderData
  }).then(response => {
    return {
      code: response.code || 200,
      data: response.data,
      message: response.message || '操作成功'
    }
  }).catch(error => {
    return {
      code: error.response?.status || 500,
      data: null,
      message: error.message || '服务器错误'
    }
  })
}
/**
 * 处理试配订单归还
 * @param {Object} returnData 归还信息
 * @returns {Promise} 返回处理结果
 */
export const processTrialReturn = (returnData) => {
  return request({
    url: '/api/orders/trial/return',
    method: 'post',
    data: returnData
  });
};

/**
 * 完成试配订单
 * @param {string} orderId 订单ID
 * @param {Object} data 完成数据
 * @returns {Promise} 返回完成结果
 */
export const completeTrialOrder = (orderId, data) => {
  return request({
    url: `/api/orders/trial/${orderId}/complete`,
    method: 'put',
    data
  });
};

/**
 * 取消试配订单
 * @param {string} orderId 订单ID
 * @param {string} reason 取消原因
 * @returns {Promise} 返回取消结果
 */
export const cancelTrialOrder = (orderId, reason) => {
  return request({
    url: `/api/orders/trial/${orderId}/cancel`,
    method: 'put',
    data: { reason }
  });
};

/**
 * 获取试配订单详情
 * @param {string} orderId 订单ID
 * @returns {Promise} 返回订单详情
 */
// 调整获取试配订单详情的方法
export function getTrialOrderDetail(orderId) {
  // 先获取订单列表
  return request({
    url: '/api/orders/trial',
    method: 'get'
  }).then(response => {
    if (response.code === 200 && Array.isArray(response.data)) {
      // 找到匹配的订单
      const order = response.data.find(o => o.id === orderId);
      if (order) {
        // 通过订单号获取详情
        return request({
          url: `/api/orders/${order.orderNo}`,
          method: 'get'
        });
      }
    }
    throw new Error('未找到订单');
  });
}
// 删除试配订单 - 修改接口地址为后端实际提供的API路径
export const deleteTrialOrder = (orderId) => {
  return request({
    url: `/api/orders/${orderId}`, // 使用正确的接口地址
    method: 'delete'
  }).then(response => {
    return {
      code: response.code || 200,
      message: response.message || '删除成功'
    }
  }).catch(error => {
    console.error('删除试配订单API错误:', error);
    return {
      code: error.response?.status || 500,
      message: error.message || '删除失败'
    }
  })
}
export default {
  getTrialOrders,
  createTrialOrder,
  getTrialOrderById,
  processTrialReturn,
  cancelTrialOrder,
  completeTrialOrder,
  getTrialOrderDetail,
  updateTrialOrder,    // 添加这个
  deleteTrialOrder,    // 添加这个
};